import React from 'react'

export default function UserIcon(props) {
    const { width = 64, height = 64, color = '#b6b6b6' } = props
    return (
        <svg t="1745742363399" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="112381" width={width} height={height}>
            <path d="M514.021746 0.3707a270.530601 270.530601 0 1 1-256.419139 269.872553A263.218963 263.218963 0 0 1 514.021746 0.3707zM43.883432 1024a288.955928 288.955928 0 0 1-7.311638-65.146693c0-203.044183 212.768662-367.556035 475.256461-367.556035s475.256461 164.511852 475.256461 367.556035a288.51723 288.51723 0 0 1-7.311638 65.146693H43.883432z" fill={color} p-id="112382"></path>
        </svg>
    )
}
